module.exports = __webpack_public_path__ + "static/02_DB-460ec128f9ec4eb8b3a9f8c8ae9d1d79.png";